import UpdateBusinessCharacteristicsRequestModelBase from '../_generated/modelBases/update-business-characteristics-request-model-base';

export default class UpdateBusinessCharacteristicsRequestModel extends UpdateBusinessCharacteristicsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
